export default __webpack_public_path__ + "media/images/icons/question-615585725457bfbf5cdc7e44e1fa6630.svg";